import EsSummaryView, {type EsSummaryViewProps} from '@/pages/components/audit-program/e-section/EsSummaryView';
import {LS_PAGE, type LSummaryPage} from '@/pages/components/audit-program/l-section/constants';

export type LsSummaryViewProps = Omit<EsSummaryViewProps, 'page' | 'fallback' | 'refCode'> & {
    page: LSummaryPage;
    refCode?: string;
};

/** Ls — Summary sheet for trade & other payables objectives. */
export default function LsSummaryView({
    page,
    refCode = 'Ls',
    ...rest
}: LsSummaryViewProps) {
    return <EsSummaryView {...rest} page={page} fallback={LS_PAGE} refCode={refCode}/>;
}
